<div class="row center bg-white bg-default-sm u-t-divider">
  <div
    *ngIf="!referenceId"
    class="request-user u-mt--large u-mw--500 col">
    <h1 class="request-user__title u-mb--medium">
      {{ "requestaccount.title" | translate }}
    </h1>
    <h5 class="request-user__description">
      {{ "requestaccount.descrtiption" | translate }}
    </h5>
    <form
      #f="ngForm"
      (ngSubmit)="submit()"
      class="o-grid--medium u-mt--medium">
      <div class="c-form-group o-grid__item col-12 col-sm-6">
        <label
          for="firstName"
          class="c-form-label"
          >{{ "requestaccount.firstname" | translate }}</label
        >
        <input
          #firstName="ngModel"
          [(ngModel)]="account.firstName"
          name="firstName"
          id="firstName"
          type="text"
          class="c-input c-input--alpha"
          [class.is-invalid]="firstName.touched && firstName.invalid"
          required />
        <div
          *ngIf="firstName.touched && firstName.invalid"
          class="c-form-alert">
          {{ "requestaccount.firstnamerequirederror" | translate }}
        </div>
      </div>
      <div class="c-form-group o-grid__item col-12 col-sm-6">
        <label
          for="lastName"
          class="c-form-label"
          >{{ "requestaccount.lastname" | translate }}</label
        >
        <input
          #lastName="ngModel"
          [(ngModel)]="account.lastName"
          name="lastName"
          id="lastName"
          type="text"
          class="c-input c-input--alpha"
          [class.is-invalid]="lastName.touched && lastName.invalid"
          required />
        <div
          *ngIf="lastName.touched && lastName.invalid"
          class="c-form-alert">
          {{ "requestaccount.lastnamerequirederror" | translate }}
        </div>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <label
          class="c-form-label"
          for="country"
          >{{ "requestaccount.country" | translate }}</label
        >
        <mat-select
          placeholder="Select Country"
          #country="ngModel"
          ngModel
          name="country"
          id="country"
          class="c-user-menu__select c-select c-select--lg"
          [class.is-invalid]="country.touched && country.invalid"
          required
          (ngModelChange)="onCountryChange(country.value)">
          <mat-option
            *ngFor="let c of countries$ | async"
            [value]="c">
            {{ c.country }}
          </mat-option>
        </mat-select>
        <div
          *ngIf="country.touched && country.invalid"
          class="c-form-alert">
          {{ "requestaccount.countryrequirederror" | translate }}
        </div>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <label
          for="email"
          class="c-form-label"
          >{{ "requestaccount.email" | translate }}</label
        >
        <input
          #email="ngModel"
          [(ngModel)]="account.email"
          name="email"
          id="email"
          type="email"
          class="c-input c-input--alpha"
          [class.is-invalid]="(email.touched && email.invalid) || userAlreadyExists"
          (ngModelChange)="validateEmail()"
          email
          required />
        <div
          *ngIf="email.touched && email.errors?.required"
          class="c-form-alert">
          {{ "requestaccount.emailrequirederror" | translate }}
        </div>
        <div
          *ngIf="email.touched && email.errors?.email"
          class="c-form-alert">
          {{ "requestaccount.emailinvaliderror" | translate }}
        </div>
        <div
          *ngIf="userAlreadyExists"
          class="c-form-alert">
          {{ "requestaccount.emailtakenerror" | translate }}
        </div>
      </div>
      <div class="c-form-group o-grid__item col-12">
        <label
          for="company"
          class="c-form-label"
          >{{ "requestaccount.company" | translate }}</label
        >
        <input
          #company="ngModel"
          [(ngModel)]="account.company"
          name="company"
          id="company"
          type="text"
          class="c-input c-input--alpha"
          [class.is-invalid]="company.touched && company.invalid"
          required />
        <div
          *ngIf="company.touched && company.invalid"
          class="c-form-alert">
          {{ "requestaccount.companyrequirederror" | translate }}
        </div>
      </div>
      <!-- TODO: Validate phone number. Add a mask for phone input -->
      <div class="c-form-group o-grid__item col-12">
        <label
          for="phoneNumber"
          class="c-form-label"
          >{{ "requestaccount.phone" | translate }}</label
        >
        <input
          #phoneNumber="ngModel"
          [(ngModel)]="account.phoneNumber"
          name="phoneNumber"
          id="phoneNumber"
          type="tel"
          class="c-input c-input--alpha"
          [class.is-invalid]="phoneNumber.touched && phoneNumber.invalid"
          required />
        <div
          *ngIf="phoneNumber.touched && phoneNumber.invalid"
          class="c-form-alert">
          {{ "requestaccount.phonerequirederror" | translate }}
        </div>
      </div>
      <!-- *Comments field is optional now and do not go anywhere. -->
      <!-- TODO: Implement comments field in API and OneService side. Also can send in email -->
      <div class="c-form-group o-grid__item col-12">
        <label
          for="address"
          class="c-form-label"
          >{{ "requestaccount.address" | translate }}</label
        >
        <textarea
          #address="ngModel"
          [(ngModel)]="account.address"
          name="address"
          id="address"
          class="c-input c-input--alpha c-textarea"
          [class.is-invalid]="address.touched && address.invalid"
          required>
        </textarea>
        <div
          *ngIf="address.touched && address.invalid"
          class="c-form-alert">
          {{ "requestaccount.addressrequirederror" | translate }}
        </div>
      </div>
      <div class="c-form-group o-grid__item col-12 u-mt--large">
        <button
          type="submit"
          class="button button-primary button-block"
          [disabled]="f.invalid || userAlreadyExists || isLoading">
          <app-loading-icon *ngIf="isLoading"></app-loading-icon>
          {{ (isLoading ? "button.pendingstate" : "button.login") | translate }}
        </button>
      </div>
    </form>
  </div>
  <div
    *ngIf="referenceId"
    class="request-user u-mt--large u-mw--600 col center">
    <fa-icon
      [icon]="faCheckCircle"
      size="6x"
      class="u-color--primary"></fa-icon>
    <h1 class="request-user__title u-mb--medium u-mt--medium">
      {{ "requestaccount.successtitle" | translate }}
    </h1>
    <h5 class="request-user__description u-mb--large">
      {{ "requestaccount.successdescription" | translate }}
    </h5>
    <div class="flex center">
      <table class="o-list-table o-list-table--bold">
        <tr class="o-list-table__item">
          <td
            scope="row"
            class="o-list-table__title">
            {{ "requestaccount.referenceid" | translate }}:
          </td>
          <td class="o-list-table__description">{{ referenceId }}</td>
        </tr>
        <tr class="o-list-table__item">
          <td
            class="o-list-table__title"
            scope="row">
            {{ "requestaccount.username" | translate }}:
          </td>
          <td class="o-list-table__description">{{ account.firstName }} {{ account.lastName }}</td>
        </tr>
        <tr class="o-list-table__item">
          <td
            class="o-list-table__title"
            scope="row">
            {{ "requestaccount.email" | translate }}:
          </td>
          <td class="o-list-table__description">{{ account.email }}</td>
        </tr>
        <tr class="o-list-table__item">
          <td
            class="o-list-table__title"
            scope="row">
            {{ "requestaccount.address" | translate }}:
          </td>
          <td class="o-list-table__description">
            <pre>{{ account.address }}</pre>
          </td>
        </tr>
      </table>
    </div>
  </div>
</div>
